module.exports = __webpack_public_path__ + "static/media/gp_icons.4d8b50c3.svg";